import React, { Component } from 'react'

export default class HeaderTitle extends Component {
    render() {
        const { titleLeft, titleRight, titleMiddle = false } = this.props;
        return (
            <div style={styles.container}>
                <div style={titleMiddle ? styles.child : {}}>{titleLeft}</div>
                {titleMiddle && <div style={{...styles.child,...{textAlign: "center"}}}>{titleMiddle}</div>}
                <div style={titleMiddle ? {...styles.child,...{textAlign: "right"}} : {}}>{titleRight}</div>
            </div>
        )
    }
}


const styles = {
    container: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
    },
    child: {
        flex: 1
    }
}